/** Stored as `source` on cases the web frontend creates (cases API and LLM orchestrator). */
export const CASE_SOURCE = "web";

/** Adds the `source` query parameter, which the LLM orchestrator stores on cases it creates. */
export function withCaseSource(url: string): string {
  return `${url}${url.includes("?") ? "&" : "?"}source=${encodeURIComponent(CASE_SOURCE)}`;
}
